import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

// When the user selects a store from the SelectProductPickupPointOfSaleDrawer
export function createPointOfSaleSelectedIntent(pointOfSaleId: string): WebViewIntent {
  return createIntent('POINT_OF_SALE_SELECTED', {
    pointOfSaleId,
  })
}

// When the user opens the store hours drawer
export function createPointOfSaleDrawerOpenIntent(): WebViewIntent {
  return createIntent('POINT_OF_SALE_DRAWER_OPEN')
}

// When the user opens the SelectShippingPickupPointOfSaleDrawer in checkout
export function createOpenSelectShippingPickupPointOfSaleDrawerIntent(): WebViewIntent {
  return createIntent('SELECT_SHIPPING_PICKUP_POINT_OF_SALE_DRAWER_OPEN')
}

// When the user selects a store from the SelectShippingPickupPointOfSaleDrawer in checkout
export function createShippingPickupPointOfSaleSelectedIntent(
  pointOfSaleId: string,
): WebViewIntent {
  return createIntent('SHIPPING_PICKUP_POINT_OF_SALE_SELECTED', {
    pointOfSaleId,
  })
}
